if (!customElements.get('ls-tabbed-grid')) {
  customElements.define(
    'ls-tabbed-grid',
    class LsTabbedGrid extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('.lstg__tab'));
        this.panels = Array.from(this.querySelectorAll('.lstg__panel'));
        this.onTabClick = this.onTabClick.bind(this);
        this.tabs.forEach((tab) => tab.addEventListener('click', this.onTabClick));
      }

      disconnectedCallback() {
        this.tabs.forEach((tab) => tab.removeEventListener('click', this.onTabClick));
      }

      onTabClick(event) {
        const target = event.currentTarget.dataset.tab;

        this.tabs.forEach((tab) => {
          const isActive = tab.dataset.tab === target;
          tab.classList.toggle('lstg__tab--active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        this.panels.forEach((panel) => {
          const isActive = panel.dataset.tab === target;
          panel.classList.toggle('lstg__panel--active', isActive);
          if (isActive) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      }
    }
  );
}
